import CenteredSpinner from '../CenteredSpinner';
import ErrorBoundary from '../ErrorBoundary';

import Map from './Map';

import type { MapWrapperProps } from '../../types';

import { isBrowser } from '@shared/utils-universal/is-browser';

const MapWrapper = (props: MapWrapperProps) =>
  isBrowser() ? (
    <ErrorBoundary componentName="GoogleMaps">
      <Map {...props} />
    </ErrorBoundary>
  ) : (
    <CenteredSpinner />
  );

export default MapWrapper;
